import { render } from "./Productos.vue?vue&type=template&id=5d8214f9"
import script from "./Productos.vue?vue&type=script&lang=js"
export * from "./Productos.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__